function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-resumo");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "adm1",
  transform: "translate(-28.000000, -134.000000)",
  fill: "#21D170",
  fillRule: "nonzero",
  stroke: "#21D170",
  strokeWidth: 0.2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(0.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-resumo",
  transform: "translate(29.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3.19744231e-14,6.63 L7.37071429,6.63 L7.37071429,-4.36539693e-13 L-3.19744231e-14,-4.36539693e-13 L-3.19744231e-14,6.63 Z M0.910714286,0.910714286 L6.46,0.910714286 L6.46,5.76785714 L0.910714286,5.76785714 L0.910714286,0.910714286 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3.19744231e-14,18.105 L7.37071429,18.105 L7.37071429,8.13571429 L-3.19744231e-14,8.13571429 L-3.19744231e-14,18.105 Z M0.910714286,9.04642857 L6.46,9.04642857 L6.46,17.1821429 L0.910714286,17.1821429 L0.910714286,9.04642857 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.28928571,18.105 L16.66,18.105 L16.66,11.475 L9.28928571,11.475 L9.28928571,18.105 Z M10.2,12.3857143 L15.7857143,12.3857143 L15.7857143,17.2428571 L10.2,17.2428571 L10.2,12.3857143 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,0 L10,10 L17,10 L17,0 L10,0 Z M16,9 L11,9 L11,1 L16,1 L16,9 Z",
  id: "Shape"
})))));

var SvgResume = function SvgResume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resume.11f36ee4.svg";
export { ForwardRef as ReactComponent };